import type { ApiClient } from './client';
import { createHttpApiClient } from './http';
import { MockApiClient } from './mock/MockApiClient';

/** Vrai quand la console tourne sur l'API simulée (VITE_API_URL absent). */
export const isMockApi = !import.meta.env.VITE_API_URL;

/**
 * Construit l'ApiClient de l'application : REST si VITE_API_URL est défini, sinon mock en mémoire.
 * `getToken` est injecté par le store d'authentification (évite une dépendance circulaire).
 */
export function createApiClient(getToken: () => string | null, onUnauthorized?: () => void): ApiClient {
  const url = import.meta.env.VITE_API_URL as string | undefined;
  // Identité (comptes, mots de passe, 2FA) : Worker siraj-backend-apps, distinct de la console.
  const authUrl = (import.meta.env.VITE_AUTH_API_URL as string | undefined) ?? url;
  return url && authUrl
    ? createHttpApiClient({ baseUrl: url, authBaseUrl: authUrl, getToken, onUnauthorized })
    : new MockApiClient({ getToken });
}
